import { useEffect } from "react";
import classes from "./Header.module.scss";
import seLogo from "../../../assets/icons/headerSeLogo.svg";
import { ReactComponent as BreadCrumb } from "../../../assets/icons/breadCrumb.svg";
import { ReactComponent as CloseIcon } from "../../../assets/icons/close_icon.svg";
import clemLogo from "../../../assets/icons/clemSolutionLogo.svg";
import clemAiLogo from "../../../assets/icons/clemAi/logo.svg";
import Button from "../../../Components/Button/Button";
import { useNavigate } from "react-router-dom";
import { useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import Redirection from "../../../assets/icons/Redirection";
import Dropdown from "./Dropdown/Dropdown";
import { Link } from "react-router-dom";
import { ReactComponent as Arrow } from "../../../assets/icons/downArrow.svg";

type Path = {
  title: string;
  path?: string;
  toCLEM?: boolean;
  pathName?: string;
  isDropdown?: boolean;
  dropdownArr?: {
    title: string;
    link: string;
    reDirect: boolean;
  }[];
};

const paths: Path[] = [
  {
    title: "About Us",
    path: "/about-us",
    pathName: "/about-us",
  },
  {
    title: "Our Solutions",
    path: "/solutions",
    pathName: "/solutions",
  },
  {
    title: "Resources",
    path: "/resources",
    isDropdown: true,
    dropdownArr: [
      {
        title: "Press Release",
        link: "/press-release",
        reDirect: false,
      },
      {
        title: "Sustainability Economics News",
        link: "https://sustainabilityeconomicsnews.com/",
        reDirect: true,
      },
      {
        title: "Next Gen.ai News",
        link: "https://ngainews.com/",
        reDirect: true,
      },
    ],
  },
  {
    title: "CEO’s Column",
    path: "/ceo-column",
    pathName: "/ceo-column",
  },
];

const getRedirectionLlinks = (path: string) => {
  if (path === "CLEM") {
    return [
      {
        title: "CLEM.ai",
        link: "/CLEM.ai",
      },
      {
        title: "SE",
        link: "/",
      },
    ];
  } else if (path === "CLEM.ai") {
    return [
      { title: "CLEM", link: "/CLEM" },
      {
        title: "SE",
        link: "/",
      },
    ];
  }
  return [
    { title: "CLEM", link: "/CLEM" },
    {
      title: "CLEM.ai",
      link: "/CLEM.ai",
    },
  ];
};

const pathLogoMappping = {
  CLEM: (
    <img className={classes["extra-logo"]} alt="CLEM Logo" src={clemLogo} />
  ),
  "CLEM.ai": (
    <img
      className={classes["extra-logo"]}
      alt="CLEM.ai Logo"
      src={clemAiLogo}
    />
  ),
};

const Header = () => {
  const resourcesRef = useRef<any>(null);

  const navigate = useNavigate();
  const location = useLocation();

  const pathSegments = location.pathname.split("/").filter(Boolean);

  const [headerPopUpVisibility, setHeaderPopupVisibility] = useState(false);
  const [dropdownVisibility, setDropdownVisibility] = useState(false);

  const navLinkClickHandler = (link: any, fromPopup?: boolean) => {
    navigate(link);

    if (fromPopup) setHeaderPopupVisibility(false);
  };

  const breadCrumbClickHandler = () => {
    setHeaderPopupVisibility((prevState) => !prevState);
  };

  const clemClickHandler = () => {
    window.open(process.env.REACT_APP_CLEM_URL, "_blank");
  };

  const linkClickHandler = (
    path: any,
    toCLEM: boolean = false,
    fromPopup: boolean = false
  ) => {
    if (toCLEM) {
      clemClickHandler();

      if (fromPopup) setHeaderPopupVisibility(false);
      return;
    }

    navLinkClickHandler(path, fromPopup);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;

      if (
        resourcesRef &&
        resourcesRef.current &&
        !resourcesRef.current.contains(target)
      ) {
        setDropdownVisibility(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const renderLogos = () => {
    return (
      <div className={classes["logos-container"]}>
        <div
          className={classes["se-logo-container"]}
          onClick={() => navLinkClickHandler("/")}
        >
          <img src={seLogo} alt="SE Logo" />
        </div>

        {pathLogoMappping[pathSegments[0] as keyof typeof pathLogoMappping] ? (
          <>
            <div className={classes["seperator"]}></div>

            {pathLogoMappping[pathSegments[0] as keyof typeof pathLogoMappping]}
          </>
        ) : null}
      </div>
    );
  };

  return (
    <>
      <div className={classes["header-container"]}>
        <div className={classes["header-left-container"]}>
          {renderLogos()}

          <div className={classes["header-links-container"]}>
            {paths.map((path) => (
              <p
                key={path.title}
                onClick={() => {
                  if (path.isDropdown) {
                    setDropdownVisibility((prev) => !prev);
                  } else {
                    linkClickHandler(path.path, path.toCLEM);
                  }
                }}
                className={
                  `/${pathSegments[0]}` === path.pathName ||
                  `/${pathSegments[1]}` === path.pathName
                    ? classes["active"]
                    : ""
                }
                ref={path.title === "Resources" ? resourcesRef : null}
              >
                {path.isDropdown && path.dropdownArr ? (
                  <>
                    {path.title}
                    <Arrow
                      style={{
                        transition: "transform 0.4s ease",
                        transform: dropdownVisibility
                          ? "rotate(180deg)"
                          : "rotate(0deg)",
                      }}
                    />
                    <Dropdown
                      dropdownArr={path.dropdownArr}
                      dropdownVisibility={dropdownVisibility}
                      parentPath="/resources"
                      containerClass={classes["dropdown-container"]}
                    />
                  </>
                ) : (
                  path.title
                )}
              </p>
            ))}
          </div>
        </div>

        <div className={classes["header-right-container"]}>
          {getRedirectionLlinks(pathSegments[0]).map((link) => (
            <Link
              to={link.link}
              className={classes["redirect-link"]}
              key={link.title}
              rel="noopener noreferrer"
              target="_blank"
            >
              {link.title} <Redirection />
            </Link>
          ))}

          <Button
            text="Get in touch"
            btnClickHandler={() => navLinkClickHandler("/contact-us")}
            className={classes["get-in-touch-btn"]}
          ></Button>
        </div>
      </div>

      <div className={classes["header-mobile"]}>
        {renderLogos()}

        <div
          className={classes["bread-crumb-container"]}
          onClick={breadCrumbClickHandler}
        >
          {headerPopUpVisibility ? (
            <div className={classes["close-icon-container"]}>
              <CloseIcon />
            </div>
          ) : (
            <BreadCrumb />
          )}
        </div>

        {headerPopUpVisibility && (
          <div
            className={
              headerPopUpVisibility
                ? `${classes["header-popup-container"]} ${classes["visible"]}`
                : `${classes["header-popup-container"]} ${classes["hide"]}`
            }
          >
            <div className={classes["hp-links-container"]}>
              {paths.map((path) => (
                <div
                  key={path.title}
                  className={`${classes["hp-link-element"]} ${
                    `/${pathSegments[0]}` === path.path ? classes["active"] : ""
                  }`}
                  ref={path.title === "Resources" ? resourcesRef : null}
                  onClick={() => {
                    if (path.isDropdown) {
                      setDropdownVisibility((prev) => !prev);
                    } else {
                      linkClickHandler(path.path, path.toCLEM, true);
                    }
                  }}
                >
                  {path.isDropdown && path.dropdownArr ? (
                    <>
                      <div className={classes["dropdown-title"]}>
                        {path.title}
                        <Arrow
                          style={{
                            transition: "transform 0.4s ease",
                            transform: dropdownVisibility
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                          }}
                        />
                      </div>

                      {dropdownVisibility && (
                        <div className={classes["mobile-dropdown-container"]}>
                          {path.dropdownArr.map((dropdown) => (
                            <div
                              key={dropdown.title}
                              className={`${classes["hp-link-element"]} ${
                                `/${pathSegments[0]}` === dropdown.link
                                  ? classes["active"]
                                  : ""
                              }`}
                              onClick={() => {
                                if (dropdown.reDirect) {
                                  window.open(dropdown.link, "_blank");
                                } else {
                                  navigate(path.path + dropdown.link);
                                }

                                setHeaderPopupVisibility(false);
                              }}
                            >
                              {dropdown.title}
                            </div>
                          ))}
                        </div>
                      )}
                    </>
                  ) : (
                    path.title
                  )}
                </div>
              ))}
            </div>

            <div className={classes["redirect-links-container"]}>
              {getRedirectionLlinks(pathSegments[0]).map((link) => (
                <Link
                  to={link.link}
                  className={classes["redirect-link"]}
                  key={link.title}
                  rel="noopener noreferrer"
                  target="_blank"
                  onClick={() => setHeaderPopupVisibility(false)}
                >
                  {link.title} <Redirection />
                </Link>
              ))}
            </div>

            <Button
              text="Get in touch"
              btnClickHandler={() => {
                navLinkClickHandler("/contact-us");
                setHeaderPopupVisibility(false);
              }}
              className={classes["get-in-touch-btn"]}
            ></Button>
          </div>
        )}
      </div>
    </>
  );
};

export default Header;
